import { EnvironmentalTargetMeasure } from "../../entities/environmentalTarget";
export const decodeProjectEnvironmentalTarget = (entity) => ({
    ...(entity.category != null ? { category: entity.category } : {}),
    ...(entity.baseline_value != null
        ? { baselineValue: entity.baseline_value }
        : {}),
    ...(entity.baseline_factor != null
        ? { baselineFactor: entity.baseline_factor }
        : {}),
    created: new Date(entity.created),
    description: entity.description,
    ...(entity.eco_labels != null ? { ecoLabels: entity.eco_labels } : {}),
    ...(entity.emission_scopes != null
        ? { emissionScopes: entity.emission_scopes }
        : {}),
    ...(entity.generation_source != null
        ? { generationSource: entity.generation_source }
        : {}),
    id: entity.project_environmental_target_id,
    // The migration backfills every row and sets the column NOT NULL, so an
    // absent value should be unreachable — but a row read through a stale
    // deployment window decodes as the measure everything meant before the
    // column existed, not as the literal string "undefined" on screen.
    measure: entity.measure ?? EnvironmentalTargetMeasure.NativeQuantity,
    measuredBy: entity.measured_by,
    ...(entity.metric_type != null ? { metricType: entity.metric_type } : {}),
    projectId: entity.project_id,
    ...(entity.share_categories != null
        ? { shareCategories: entity.share_categories }
        : {}),
    ...(entity.source_framework_id != null
        ? { sourceFrameworkId: entity.source_framework_id }
        : {}),
    ...(entity.source_framework_target_id != null
        ? { sourceFrameworkTargetId: entity.source_framework_target_id }
        : {}),
    ...(entity.sub_category != null ? { subCategory: entity.sub_category } : {}),
    targetMethod: entity.target_method,
    ...(entity.target_type != null ? { targetType: entity.target_type } : {}),
    targetValue: entity.target_value,
    ...(entity.waste_disposal_destinations != null
        ? { wasteDisposalDestinations: entity.waste_disposal_destinations }
        : {}),
    ...(entity.waste_hazardous != null
        ? { wasteHazardous: entity.waste_hazardous }
        : {})
});
export const encodeProjectEnvironmentalTarget = (lineItem) => ({
    ...(lineItem.category != null ? { category: lineItem.category } : {}),
    ...(lineItem.baselineValue != null
        ? { baseline_value: lineItem.baselineValue }
        : {}),
    ...(lineItem.baselineFactor != null
        ? { baseline_factor: lineItem.baselineFactor }
        : {}),
    created: lineItem.created,
    description: lineItem.description,
    ...(lineItem.ecoLabels != null ? { eco_labels: lineItem.ecoLabels } : {}),
    ...(lineItem.emissionScopes != null
        ? { emission_scopes: lineItem.emissionScopes }
        : {}),
    ...(lineItem.generationSource != null
        ? { generation_source: lineItem.generationSource }
        : {}),
    measure: lineItem.measure,
    measured_by: lineItem.measuredBy,
    ...(lineItem.metricType != null ? { metric_type: lineItem.metricType } : {}),
    project_environmental_target_id: lineItem.id,
    project_id: lineItem.projectId,
    ...(lineItem.shareCategories != null
        ? { share_categories: lineItem.shareCategories }
        : {}),
    ...(lineItem.sourceFrameworkId != null
        ? { source_framework_id: lineItem.sourceFrameworkId }
        : {}),
    ...(lineItem.sourceFrameworkTargetId != null
        ? { source_framework_target_id: lineItem.sourceFrameworkTargetId }
        : {}),
    ...(lineItem.subCategory != null
        ? { sub_category: lineItem.subCategory }
        : {}),
    target_method: lineItem.targetMethod,
    ...(lineItem.targetType != null ? { target_type: lineItem.targetType } : {}),
    target_value: lineItem.targetValue,
    ...(lineItem.wasteDisposalDestinations != null
        ? { waste_disposal_destinations: lineItem.wasteDisposalDestinations }
        : {}),
    ...(lineItem.wasteHazardous != null
        ? { waste_hazardous: lineItem.wasteHazardous }
        : {})
});
